import React, { Component } from 'react';
import '../../../resources/AdminStandardPage.css';
import AuthenticationService from '../../../services/AuthenticationService';
import DeletePUGCertificates from '../../../components/Dialogs/DeleteDialog/DeleteDialog';
import AttachmentField from '../../../components/AttachmentField/AttachmentField';
import NotificationSystem from 'react-notification-system';
import NotificationSystemStyle from '../../../constants/NotificationSystemStyle';
import { minuteService } from '../../../services/MinutesService';
import ReactPaginate from 'react-paginate';

class Minutes extends Component {
  constructor(props) {
    super(props);

    this.state = {
      disabledDocument: false,
      newMinute: {
        title: '',
        document: '',
        date:''
      },
      existingMinutes: [],
      deleteMinutesDocuments: {
        openedDialog: false,
        deleteId: 0
      },
      pagination: {}
    };

    this.authentication = new AuthenticationService();
  }

  componentWillMount() {
    minuteService
      .getAll()
      .then(jsonResponse => {
        this.setMinuteDocumentState(jsonResponse);
      })
      .catch(error => console.log(error));
  }

  componentDidMount() {
    this._notificationSystem = this.refs.notificationSystem;
  }

  handlePageClick = selectedPage => {
    minuteService
      .getAll(selectedPage.selected + 1)
      .then(jsonResponse => {
        this.setMinuteDocumentState(jsonResponse);
      })
      .catch(error => console.log(error));
  };

  setMinuteDocumentState = response => {
    let existingMinutes = { ...this.state.existingMinutes };
    let pagination = { ...this.state.pagination };
    existingMinutes = response.local_public_meetings_minutes;
    pagination = response.pagination;

    this.setState({ existingMinutes });
    this.setState({ pagination });
  };

  updateField = event => {
    const field = event.target.name;
    const newMinute = this.state.newMinute;
    newMinute[field] = event.target.value;

    this.setState({
      newMinute
    });
  };

  onDropDocument = documents => {
    let newMinute = { ...this.state.newMinute };
    let reader = new FileReader();
    let self = this;

    reader.onload = function(upload) {
      newMinute.document = documents[0];

      self.setState({ newMinute });
      self.setState({ disabledDocument: true });
    };
    reader.readAsDataURL(documents[0]);
  };

  removeDocument = () => {
    let newMinute = { ...this.state.newMinute };
    newMinute.document = null;

    this.setState({ newMinute });
    this.setState({ disabledDocument: false });
  };

  resetForm = () => {
    let newMinute = { ...this.state.newMinute };
    newMinute = {
      title: '',
      document: ''
    };

    this.setState({ newMinute });
    this.setState({ disabledDocument: false });
  };

  handleFormSubmit = event => {
    event.preventDefault();
    const currentId = this.state.newMinute.id;

    const headers = {
      Accept: 'application/json'
    };

    if (this.authentication.loggedIn()) {
      headers['Authorization'] = 'Bearer ' + this.authentication.getToken();
    }

    let url = `${
      process.env.REACT_APP_API_URL
    }/api/local_public_meetings_minutes/`;
    let callMethod = 'POST';

    if (currentId) {
      url = `${
        process.env.REACT_APP_API_URL
      }/api/local_public_meetings_minutes/${this.state.newMinute.id}`;
      callMethod = 'PUT';
    }

    const formattedData = this.buildFormData();

    fetch(url, {
      method: callMethod,
      body: formattedData,
      headers
    })
      .then(this.handleErrors)
      .then(response => response.json())
      .then(jsonResponse => {
        this.resetForm();

        let existingMinutes = this.state.existingMinutes.slice();

        let index = existingMinutes.findIndex(
          existingregisterDocument =>
            existingregisterDocument.id === jsonResponse.id
        );

        if (index !== -1) {
          existingMinutes[index] = jsonResponse;
        } else {
          existingMinutes.push(jsonResponse);
        }

        this.setState({ existingMinutes });

        if (currentId) {
          this._notificationSystem.addNotification({
            message: 'Documentul a fost editat cu success.',
            level: 'success',
            position: 'tc'
          });
        } else {
          this._notificationSystem.addNotification({
            message: 'Documentul a fost adaugat cu success.',
            level: 'success',
            position: 'tc'
          });
        }
      })
      .catch(error => {
        this._notificationSystem.addNotification({
          message:
            'A aparut o problema, faceti refresh la pagina sau contactati administratorul daca problema persista.',
          level: 'error',
          position: 'tc'
        });
      });
  };

  buildFormData() {
    let formData = new FormData();
    formData.append(
      'local_public_meetings_minute[title]',
      this.state.newMinute.title
    );
    formData.append(
      'local_public_meetings_minute[add_date]',
      this.state.newMinute.date
    );

    if (this.state.newMinute.document) {
      let document = this.state.newMinute.document;
      formData.append(
        `local_public_meetings_minute[document]`,
        document,
        document.name
      );
    }

    return formData;
  }

  setMinuteDocumentForEdit = newRegisterDoc => {
    let newMinute = { ...this.state.newMinute };
    newMinute = Object.assign({}, newRegisterDoc);
    this.setState({ newMinute });

    if (newMinute.document.url) {
      this.setState({ disabledDocument: true });
    }
  };

  openDeleteDialog = id => {
    let deleteMinutesDocuments = { ...this.state.deleteMinutesDocuments };
    deleteMinutesDocuments = {
      openedDialog: true,
      deleteId: id
    };

    this.setState({ deleteMinutesDocuments });
  };

  closeDeleteDialog = () => {
    let deleteMinutesDocuments = { ...this.state.deleteMinutesDocuments };
    deleteMinutesDocuments = {
      openedDialog: false,
      deleteId: 0
    };

    this.setState({ deleteMinutesDocuments });
  };

  handleDelete = () => {
    minuteService
      .deleteMinute(this.state.deleteMinutesDocuments.deleteId)
      .then(() => {
        let existingMinutes = this.state.existingMinutes.slice();
        existingMinutes = existingMinutes.filter(
          registerDocument =>
            registerDocument.id !== this.state.deleteMinutesDocuments.deleteId
        );
        this.setState({ existingMinutes });

        this.closeDeleteDialog();

        this._notificationSystem.addNotification({
          message: 'Documentul a fost stears cu success.',
          level: 'success',
          position: 'tc'
        });
      })
      .catch(error => {
        this._notificationSystem.addNotification({
          message:
            'A aparut o problema, faceti refresh la pagina sau contactati administratorul daca problema persista.',
          level: 'error',
          position: 'tc'
        });
      });
  };

  handleErrors = response => {
    if (!response.ok) {
      throw Error(response.statusText);
    }
    return response;
  };

  render() {
    return (
      <div className="admin-standard-page">
        <div className="admin-standard-page__title">
          <h3 className="admin-page__profile-title profile-title-specific">
            Interes Public
          </h3>
          <h1 className="admin-switch-title default-title admin-long-title">
            {' '}
            Minute ședințe publice locale
          </h1>
        </div>
        <div className="title-line" />
        <div className="admin-standard-page__content">
          <div className="admin-standard-page__create-project">
            <div className="card">
              <form className="admin-form" onSubmit={this.handleFormSubmit}>
                <h2 className="admin-form__title">Adauga un document nou</h2>

                <div className="admin-form__field">
                  <h4 className="label-title label-title-provisions">Titlu*</h4>
                  <input
                    required
                    className="general-field title-field"
                    type="text"
                    name="title"
                    onChange={this.updateField}
                    value={this.state.newMinute.title}
                  />
                </div>
                <div className="admin-form__field">
                  <h4 className="label-title label-title-provisions">Data*</h4>
                  <input
                    required
                    className="general-field title-field"
                    type="date"
                    name="date"
                    onChange={this.updateField}
                    value={this.state.newMinute.date}
                  />
                </div>
                <div className="admin-form__upload">
                  <h4 className="label-title label-title-provisions">
                    Document:
                  </h4>
                  <AttachmentField
                    onDrop={this.onDropDocument}
                    removeDocument={this.removeDocument}
                    disabledDocuments={this.state.disabledDocument}
                    document={this.state.newMinute.document}
                    documentFilename={this.state.newMinute.document_filename}
                    type="application/pdf"
                  />
                </div>
                <div className="form-buttons">
                  <div className="admin-form__submit">
                    <button
                      type="submit"
                      className="submit-button general-button"
                    >
                      {this.state.newMinute.id
                        ? 'Editează Registru'
                        : 'Adaugă Registru'}
                    </button>
                  </div>
                  {Object.values(this.state.newMinute) && (
                    <button
                      type="button"
                      className="general-button reset-button"
                      onClick={() => this.resetForm()}
                    >
                      Resetează câmpurile
                    </button>
                  )}
                </div>
              </form>
            </div>
          </div>
          {this.state.existingMinutes.length > 0 && (
            <div className="admin-standard-page__existing-items">
              <div className="card">
                <div className="existing-items">
                  <h2 className="existing-items__title label-title">
                    Minute existente
                  </h2>
                  <div className="existing-items__content">
                    {this.state.existingMinutes.map(registerDocument => (
                      <div
                        className="existing-items__content-card"
                        key={registerDocument.id}
                      >
                        <div className="card-content provisions-title-content">
                          <h3 className="major-provisions-title">
                            {registerDocument.title}
                          </h3>
                        </div>
                        <div className="existing-items__actions-card">
                          <div
                            className="provisions-title-content"
                            onClick={() =>
                              this.setMinuteDocumentForEdit(registerDocument)
                            }
                          >
                            <h4 className="action-title"> Editează</h4>
                          </div>

                          <div
                            className="provisions-title-content"
                            onClick={() =>
                              this.openDeleteDialog(registerDocument.id)
                            }
                          >
                            <h4 className="action-title delete-button">
                              {' '}
                              Șterge
                            </h4>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                  <DeletePUGCertificates
                    opened={this.state.deleteMinutesDocuments.openedDialog}
                    handleClose={this.closeDeleteDialog}
                    handleDelete={this.handleDelete}
                    headline="Sunteti sigur ca doriti sa stergeti acest document?"
                    aditionalText="Dupa stergere, documentul nu va mai putea fi recuperat."
                  />
                </div>
                {this.state.pagination.last_page > 1 && (
                  <ReactPaginate
                    previousLabel={'<'}
                    nextLabel={'>'}
                    breakLabel={'...'}
                    breakClassName={'break-me'}
                    pageCount={this.state.pagination.last_page}
                    marginPagesDisplayed={1}
                    pageRangeDisplayed={2}
                    onPageChange={this.handlePageClick}
                    containerClassName={'pagination'}
                    subContainerClassName={'pages pagination'}
                    activeClassName={'active'}
                  />
                )}
              </div>
            </div>
          )}
        </div>
        <NotificationSystem
          ref="notificationSystem"
          style={NotificationSystemStyle}
        />
      </div>
    );
  }
}

export default Minutes;
